export enum Platform {
  ANDROID = 'PLATFORM_ANDROID',
  IOS = 'PLATFORM_IOS',
}

export interface ClientMetadata {
  isBrandedApp?: boolean
  platform?: Platform
  gclid?: string
}
